import Common_Banner from "../Common_Components/Common_Heading/Common_Banner/Common_Banner";
import HowWeWork from "../Process/How_We_Work/How_We_Work";
import Business_Hours from "./Business_Hours/Business_Hours";
import Contact_Form from "./contact_form/Contact_Form";
import Contact_Grid from "./Contact_Grid/Contact_Grid";
import FAQ from "./faq/FAQ";
import Map_View from "./map_view/Map_View";
import Why_Contact_Us from "./why _contact_us/Why_Contact_Us";
import Ready_To_Start from "../Home/Ready_To_Start/Ready_To_Start";

const Contact_Us = () => {
  return (
    <>
      <Common_Banner
        image="/assets/images/home/hero_city_buildings.jpg"
        title="Get In Touch"
        subtitle="We're here to help! Contact us for any queries about overseas job opportunities"
      />
      <Contact_Grid />

      <Business_Hours />

      <HowWeWork />
      <Contact_Form />
      <Map_View />
      <Why_Contact_Us />
      <FAQ />
      <Ready_To_Start />
    </>
  );
};

export default Contact_Us;
